import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import {AvatarPlaceholder} from '../../../../uikit/AvatarPlaceholder';
import * as S from './styles';
import {TestID} from './test_ids';

export const ProgramInvitesListItemJSX: FC<Props> = ({
  avatar,
  courseLabel,
  initialEmail,
  isInviteByEmail,
  label,
  message,
  name,
  onCancelButtonClick,
  onResendButtonClick,
}) => {
  const {t} = useI18n();

  const renderLabel = () =>
    label ? <S.Label testID={TestID.label}>{label}</S.Label> : null;

  const renderCourseDates = () => (
    <S.CourseDatesContainer>
      <S.CalendarIcon />
      <S.CourseLabel testID={TestID.course_label}>{courseLabel}</S.CourseLabel>
    </S.CourseDatesContainer>
  );

  return (
    <S.Wrapper>
      <S.Container testID={TestID.container}>
        <S.ContentWrapper>
          <S.Avatar
            placeholder={
              isInviteByEmail ? (
                <S.EmailAvatarPlaceholder>
                  <S.EmailAvatarPlaceholderIcon />
                </S.EmailAvatarPlaceholder>
              ) : (
                <AvatarPlaceholder text={name} />
              )
            }
            src={isInviteByEmail ? '' : avatar}
            testID={TestID.avatar}
          />
          <S.Content>
            <S.Name testID={TestID.name}>{name}</S.Name>
            {initialEmail ? (
              <S.Label testID={TestID.initial_email}>{initialEmail}</S.Label>
            ) : null}
            {renderLabel()}
          </S.Content>
        </S.ContentWrapper>
        {courseLabel ? renderCourseDates() : null}
        <S.ButtonsContainer>
          <S.ResendButton
            onClick={onResendButtonClick}
            testID={TestID.button_resend}
          >
            <S.ResendButtonText>{t('shared:resend')}</S.ResendButtonText>
          </S.ResendButton>
          <S.CancelButton
            onClick={onCancelButtonClick}
            testID={TestID.button_cancel}
          >
            <S.CancelButtonText>{t('shared:cancel')}</S.CancelButtonText>
          </S.CancelButton>
        </S.ButtonsContainer>
      </S.Container>
      {message ? (
        <S.MessageContainer>
          <S.Message testID={TestID.message}>{message}</S.Message>
        </S.MessageContainer>
      ) : null}
    </S.Wrapper>
  );
};
